// src/components/PreviewModal.tsx
import React from 'react';
import ReactDOM from 'react-dom';

interface PreviewModalProps {
  previewUrl: string;
  onClose: () => void;
}

export const PreviewModal: React.FC<PreviewModalProps> = ({
  previewUrl,
  onClose,
}) => {
  const src = `${previewUrl}${
    previewUrl.includes('?') ? '&' : '?'
  }t=${Date.now()}`;
  return ReactDOM.createPortal(
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '90%',
          height: '90%',
          background: 'white',
          borderRadius: 8,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <button onClick={onClose} style={{ alignSelf: 'flex-end', margin: 8 }}>
          ×
        </button>
        <iframe
          src={src}
          style={{ flex: 1, border: 0 }}
          title="Engagement Letter Preview"
        />
      </div>
    </div>,
    document.body,
  );
};
